import { LogOut, Settings, UserRoundCog } from "lucide-react";
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { can_visit, getInitials } from "../../helpers";
import ChangePasswordModal from "../Modal/ChangePasswordModal";
import SetupOTPModal from "../Modal/SetupOTPModal"
import { Drawer } from 'vaul';
import AdminNav from "./AdminNav";
import { useLogout } from "../../hooks/useLogout";

export default function UserDropdown({ profile, setEnablejoyride, setTourType }) {
  const [activeModal, setActiveModal] = useState(false);
  const [otpActiveModal, setOtpActiveModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [drawerPosition, setDrawerPosition] = useState({ top: 0 });
  const dropdownRef = useRef(null);
  const portalLogout = useLogout();

  const calculateDrawerPosition = () => {
    const triggerElement = document.querySelector('.docpro_btn');
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY
      });
    }
  };

  return (
    <>
      <div className="relative" ref={dropdownRef}>
        <Drawer.Root open={isOpen} onOpenChange={setIsOpen}>
          <Drawer.Trigger
            className="docpro_btn"
            onClick={calculateDrawerPosition}
          >
            <div className="docpro_header_avatar">
              {getInitials(`${profile.first_name} ${profile.last_name}`)}{" "}
              <span className="docpro_tip">{`${profile.first_name} ${profile.last_name}`}</span>
            </div>
          </Drawer.Trigger>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay" />
            <Drawer.Content 
              className="docpro_drawer_content docpro_drawer_style_3"
              style={{ top: drawerPosition.top }}
            >
              <Drawer.Title className="sr-only">User Menu</Drawer.Title>
              <Drawer.Description className="sr-only">
                A menu for the user to manage their profile, settings, and log out.
              </Drawer.Description>

              <div className="docpro_dropdown docpro_small_user_dropdown">
                <Link to={`${can_visit('_role_trial') ? 'trial' : '/profile'}`} onClick={() => setIsOpen(false)} className={`${can_visit('_role_trial') && 'trial'} docpro_dropdown_item`}>
                  <UserRoundCog height={16} width={16} /> Profile
                </Link>
                {can_visit("settings") && (
                  <div className="docpro_settings_navigation">
                    <div className="docpro_settings_navigation_1">
                      <Link to={`${can_visit('_role_trial') ? 'trial' : '/admin/settings'}`} onClick={() => setIsOpen(false)} className={`${can_visit('_role_trial') && 'trial'} docpro_dropdown_item`}>
                        <Settings height={16} width={16} /> Settings
                      </Link>
                    </div>
                    <div className="docpro_settings_navigation_2">
                      <AdminNav setIsOpen={setIsOpen} />
                    </div>
                  </div>
                )}
                <hr />
                <span onClick={portalLogout} className="docpro_dropdown_item">
                  <LogOut height={16} width={16} /> Log Out
                </span>
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>

      {activeModal && (
        <ChangePasswordModal
          activeModal={activeModal}
          setActiveModal={setActiveModal}
        />
      )}
      {otpActiveModal && (
        <SetupOTPModal
          activeModal={otpActiveModal}
          setActiveModal={setOtpActiveModal}
        />
      )}
    </>
  );
}
